export default "__VITE_ASSET__4d2e7bab__"